const errors = {
    success: 'Successfull status',
    cancel: 'Cancelled status',
    unauthorized: 'Unauthorized'
}

export default errors;